<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 17:41:45
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-02-28 20:14:25
-->
<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="10">
			<platform-tab @change="handleClickTab" :platformId="platformId" v-if="$auth.hasPermi('system:ranking-commd-view')" />
			<div v-if="$auth.hasPermi('system:ranking-commd-view')">
				<tab ref="tab" :viewOptions="viewOptions" :platformId="platformId"></tab>
				<auth ref="auth" :platformId="platformId"></auth>
			</div>
			<div v-else>
				<empty ref="empty">
					<img slot="image" src="@/assets/public/admin-img.png" alt="" />
					<div class="fz-14 yx-color-text-regular mt-10" slot="desc">
						<p>暂无权限查看</p>
						<p>可联系管理员开通查看团队总排行榜权限</p>
					</div>
				</empty>
			</div>
		</Panel>
	</div>
</template>
<script>
import tab from './components/tab.vue';
import { mapGetters } from 'vuex';
import empty from '@/views/common/empty/index.vue';
import Auth from '../../components/auth.vue';
export default {
	name: 'index',
	components: {
		tab,
		empty,
		Auth,
	},
	data() {
		return {
			platformId: +dataMap.PLATFORM_DY.value,
		};
	},
	computed: {
		...mapGetters(['defaultPlatform']),
		viewOptions() {
			let obj1 = {
				label: '查看团队内所有数据',
				value: 1,
			};
			let obj2 = {
				label: '仅查看自己的数据',
				value: 2,
			};
			return [obj2, obj1];
		},
	},
	created() {
		this.platformId = this.$route.query.platformId || +this.defaultPlatform;
	},
	methods: {
		handleClickTab(val) {
			this.platformId = val;
			this.$nextTick(() => {
				this.$refs.tab.refreshPage();
				this.$refs.tab.getList();
			});
		},
		selectFun(e) {
			this.$refs.tab.selectFun(e);
		},
	},
};
</script>
<style lang="less" scoped>
.see-auth {
	position: absolute;
	top: 15px;
	right: 20px;
	cursor: pointer;
	z-index: 999;
}
</style>
